module.exports = {
    "Albany": "Albany, N.Y.",
    "Birmingham": "Birmingham, Ala.",
    "Buffalo-Rochester": "Buffalo-Rochester, N.Y.",
    "Charlotte": "Charlotte, N.C.",
    "Columbus": "Columbus, Ohio",
    "Des Moines": "Des Moines, Iowa",
    "Grand Rapids": "Grand Rapids, Mich.",
    "Greenville": "Greenville, S.C.",
    "Hartford-New Haven": "Hartford-New Haven, Conn.",
    "Indianapolis": "Indianapolis, Ind.",
    "Jacksonville": "Jacksonville, Fla.",
    "Kansas City": "Kansas City, Mo.",
    "Little Rock": "Little Rock, Ark.",
    "Louisville": "Louisville, Ky.",
    "Memphis": "Memphis, Tenn.",
    "Nashville": "Nashville, Tenn.",
    "New Orleans-Mobile": "New Orleans, La.-Mobile, Ala.",
    "Oahu": "Oahu, Hawaii",
    "Oklahoma City-Tulsa": "Oklahoma City-Tulsa, Okla.",
    "Omaha": "Omaha, Neb.",
    "Orlando": "Orlando, Fla.",
    "Portland": "Portland, Ore.",
    "Raleigh-Durham": "Raleigh-Durham, N.C.",
    "Richmond": "Richmond, Va.",
    "Sacramento": "Sacramento, Calif.",
    "Salt Lake City-Boise": "Salt Lake City, Utah-Boise, Idaho",
    "San Antonio": "San Antonio, Texas",
    "St Louis": "St. Louis",
    "Syracuse": "Syracuse, N.Y.",
    "Tampa": "Tampa, Fla.",
    "Washington D.C.": "Washington, D.C.",
    "West Texas": "West Texas, Texas"
  }
  